import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../../../../services/api.service";
import {Title} from "@angular/platform-browser";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
  standalone: false
})
export class EmailVerificationComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: '/app/users/dashboard'},
    { label: 'Dashboard', path: '/app/users/dashboard'},
    { label: 'Email Verification'}
  ];

  emailVerificationCode: string = '';

  showMessages: boolean = false;
  messages: any[] = [];
  username: string = '';
  sendCount: number = 0;

  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService: UserService,
              private routerChild: Router, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    titleService.setTitle("Scalanthropy Email Verification")
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // @ts-ignore
    this.username = localStorage.getItem("username");
    this.resendEmailVerificationCode();
  }

  showMessagesToUser(): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  onVerifyEmail(): any {
    this.pageSuccessMessages = [];
    this.pageErrorMessages = [];
    const emailVerificationCodeEl = document.getElementById('email-verification-code-text-id');
    // @ts-ignore
    this.emailVerificationCode = emailVerificationCodeEl.value;
    if (!this.emailVerificationCode) {
      this.pageErrorMessages.push({
        field: 'Email Verification Code',
        detail: 'Email Verification Code: ' + this.emailVerificationCode + ' is not valid. You may need resend a new one',
        severity: 'error'
      });
    }
    // @ts-ignore
    if (!this.username) {
      this.pageErrorMessages.push({
        field: 'Username Not Found',
        detail: 'Username Not Found In Request: Please login again.',
        severity: 'error'
      });
      this.routerChild.navigateByUrl('app/login');
      return;
    }

    if (this.pageErrorMessages.length > 0) {
      this.showPageErrorMessagesToUser(10000);
      return;
    }

    this.userService.verifyEmailCode(this.username, this.emailVerificationCode).subscribe((result: any) => {
      if (result && result.body) {
        if (result.body.emailCodeVerifiedFlag == 'Y') {
          this.auth2ServiceChild.setEmailCodeVerifiedFlag(result.body.emailCodeVerifiedFlag);
          this.pageSuccessMessages.push({
            field: 'Successfully verify email',
            detail: "Email successfully verified.",
            severity: 'success'
          });
          this.showPageErrorMessagesToUser(10000);
          this.routerChild.navigateByUrl('app/users/dashboard');
        } else {
          this.auth2ServiceChild.setEmailCodeVerifiedFlag(result.body.emailCodeVerifiedFlag);
          this.pageErrorMessages.push({
            field: 'Failed to verify email',
            detail: "You entered an incorrect code.",
            severity: 'error'
          });
          this.showPageErrorMessagesToUser(10000);
        }
      }
    }, (err: HttpErrorResponse) => {
      this.pageErrorMessages.push({
          field: 'Failed to verify email',
          detail: err.error.message,
          severity: 'error'
      });
      this.showPageErrorMessagesToUser(10000);
    })
  }

  resendEmailVerificationCode(): void {
    this.pageSuccessMessages = [];
    this.pageErrorMessages = [];
    this.userService.resendEmailCode(this.username).subscribe((result: any) => {
      if (result && result.body) {
        if (this.sendCount == 0) {
          this.pageSuccessMessages.push({
            field: 'Email Verification Code',
            detail: 'Email Verification Code sent to ' + this.username,
            severity: 'success'
          });
          this.sendCount = 1;
        } else {
          this.pageSuccessMessages.push({
            field: 'Email Verification Code Resent',
            detail: 'Email Verification Code Resent',
            severity: 'success'
          });
        }
        this.showPageSuccessMessagesToUser(8000)
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Error',
        detail: 'Email Verification Code failed to resend: Please try again.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser(8000);
    });
  }
}
